import axios from 'axios'

const image = url => {
  return axios(`https://kennykrosky.com/image-data-uri/?image=${url}`)
  .then((res) => {
    document.querySelector('.image').style.backgroundImage = `url(${res.data})`
    return res.data
  })
  .catch((error) => console.log('err'))
}

export default image